import { render } from "./TravelPassJourneySearch.vue?vue&type=template&id=124a3dbc&scoped=true&lang=pug"
import script from "./TravelPassJourneySearch.vue?vue&type=script&lang=ts"
export * from "./TravelPassJourneySearch.vue?vue&type=script&lang=ts"

import "./TravelPassJourneySearch.vue?vue&type=style&index=0&id=124a3dbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-124a3dbc"

export default script